import { z } from "zod";
import { zRootBimObjectJson } from "./z-bim-object";
import { zTemplateLoadType } from "./z-pipe-settings";

export const zOrgApartmentTemplate = z.object({
	id: z.string(),
	loadType: zTemplateLoadType,
	template: zRootBimObjectJson,
});

const zOrgApartmentGroup = z.object({
	id: z.string(),
	name: z.string(),
	color: z.string(),
	mixRatio: z.number(),
	mixLocked: z.boolean(),
	apartmentTemplates: z.array(zOrgApartmentTemplate),
});

const zOrgApartmentSet = z.object({
	id: z.string(),
	name: z.string(),
	corridorWidth: z.number(),
	orgId: z.string().nullable(),
	isDefault: z.boolean(),
	apartmentGroups: z.array(zOrgApartmentGroup),
});

export const zGetOrgApartmentSetsRes = z.array(zOrgApartmentSet);

export type ApartmentTemplate = z.infer<typeof zOrgApartmentTemplate>;
export type ApartmentGroup = z.infer<typeof zOrgApartmentGroup>;
export type ApartmentSet = z.infer<typeof zOrgApartmentSet>;
export type ApartmentSets = z.infer<typeof zGetOrgApartmentSetsRes>;
